import { Component } from '@angular/core';

import { pedidoAprovado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-aprovado',
    templateUrl: './pedido-status-badge-aprovado.component.html',
    styleUrls: ['./pedido-status-badge-aprovado.component.less']
})
export class PedidoStatusBadgeAprovadoComponent {
    status = pedidoAprovado;
}
